export const BankOfferTypes = {
	KEYS: 'keys',
	TICKETS: 'tickets',
	PACK: 'pack',
	CHAPTER_PASS: 'chapter_pass',
	EVENT_HALLOWEEN: 'event_halloween',
	EVENT_CHRISTMAS: 'event_christmas',
	EVENT_VALENTINES_DAY: 'event_valentines_day',
} as const

export type BankOfferType = (typeof BankOfferTypes)[keyof typeof BankOfferTypes]

export function offerIsUnique(type: BankOfferType) {
	return type !== BankOfferTypes.KEYS && type !== BankOfferTypes.TICKETS && type !== BankOfferTypes.CHAPTER_PASS
}

export function shouldOfferTickets(type: BankOfferType) {
	return type !== BankOfferTypes.KEYS
}

export function shouldOfferKeys(type: BankOfferType) {
	return type !== BankOfferTypes.TICKETS && type !== BankOfferTypes.CHAPTER_PASS
}

export function isEventType(type: string) {
	return (
		type === BankOfferTypes.EVENT_HALLOWEEN ||
		type === BankOfferTypes.EVENT_CHRISTMAS ||
		type === BankOfferTypes.EVENT_VALENTINES_DAY
	)
}
